/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PublicContinuityOfCareModule } from './PublicContinuityOfCareModule';
import {
    PublicContinuityOfCareModuleFromJSON,
    PublicContinuityOfCareModuleFromJSONTyped,
    PublicContinuityOfCareModuleToJSON,
} from './PublicContinuityOfCareModule';
import type { PublicModule } from './PublicModule';
import {
    PublicModuleFromJSON,
    PublicModuleFromJSONTyped,
    PublicModuleToJSON,
} from './PublicModule';
import type { PublicReferralProgramModule } from './PublicReferralProgramModule';
import {
    PublicReferralProgramModuleFromJSON,
    PublicReferralProgramModuleFromJSONTyped,
    PublicReferralProgramModuleToJSON,
} from './PublicReferralProgramModule';
import type { PublicStripeModule } from './PublicStripeModule';
import {
    PublicStripeModuleFromJSON,
    PublicStripeModuleFromJSONTyped,
    PublicStripeModuleToJSON,
} from './PublicStripeModule';

/**
 * 
 * @export
 * @interface PublicTenantModules
 */
export interface PublicTenantModules {
    /**
     * 
     * @type {PublicModule}
     * @memberof PublicTenantModules
     */
    dynacare?: PublicModule;
    /**
     * 
     * @type {PublicModule}
     * @memberof PublicTenantModules
     */
    fax?: PublicModule;
    /**
     * 
     * @type {PublicModule}
     * @memberof PublicTenantModules
     */
    sms?: PublicModule;
    /**
     * 
     * @type {PublicModule}
     * @memberof PublicTenantModules
     */
    blog?: PublicModule;
    /**
     * 
     * @type {PublicModule}
     * @memberof PublicTenantModules
     */
    twoFactorAuth?: PublicModule;
    /**
     * 
     * @type {PublicModule}
     * @memberof PublicTenantModules
     */
    ses?: PublicModule;
    /**
     * 
     * @type {PublicStripeModule}
     * @memberof PublicTenantModules
     */
    stripe?: PublicStripeModule;
    /**
     * 
     * @type {PublicModule}
     * @memberof PublicTenantModules
     */
    cycleTracking?: PublicModule;
    /**
     * 
     * @type {PublicModule}
     * @memberof PublicTenantModules
     */
    careyChat?: PublicModule;
    /**
     * 
     * @type {PublicModule}
     * @memberof PublicTenantModules
     */
    careyEmail?: PublicModule;
    /**
     * 
     * @type {PublicReferralProgramModule}
     * @memberof PublicTenantModules
     */
    referralProgram?: PublicReferralProgramModule;
    /**
     * 
     * @type {PublicModule}
     * @memberof PublicTenantModules
     */
    executiveReports?: PublicModule;
    /**
     * 
     * @type {PublicContinuityOfCareModule}
     * @memberof PublicTenantModules
     */
    continuityOfCare?: PublicContinuityOfCareModule;
    /**
     * 
     * @type {PublicModule}
     * @memberof PublicTenantModules
     */
    refillRequests?: PublicModule;
}

/**
 * Check if a given object implements the PublicTenantModules interface.
 */
export function instanceOfPublicTenantModules(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PublicTenantModulesFromJSON(json: any): PublicTenantModules {
    return PublicTenantModulesFromJSONTyped(json, false);
}

export function PublicTenantModulesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicTenantModules {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dynacare': !exists(json, 'dynacare') ? undefined : PublicModuleFromJSON(json['dynacare']),
        'fax': !exists(json, 'fax') ? undefined : PublicModuleFromJSON(json['fax']),
        'sms': !exists(json, 'sms') ? undefined : PublicModuleFromJSON(json['sms']),
        'blog': !exists(json, 'blog') ? undefined : PublicModuleFromJSON(json['blog']),
        'twoFactorAuth': !exists(json, 'twoFactorAuth') ? undefined : PublicModuleFromJSON(json['twoFactorAuth']),
        'ses': !exists(json, 'ses') ? undefined : PublicModuleFromJSON(json['ses']),
        'stripe': !exists(json, 'stripe') ? undefined : PublicStripeModuleFromJSON(json['stripe']),
        'cycleTracking': !exists(json, 'cycleTracking') ? undefined : PublicModuleFromJSON(json['cycleTracking']),
        'careyChat': !exists(json, 'careyChat') ? undefined : PublicModuleFromJSON(json['careyChat']),
        'careyEmail': !exists(json, 'careyEmail') ? undefined : PublicModuleFromJSON(json['careyEmail']),
        'referralProgram': !exists(json, 'referralProgram') ? undefined : PublicReferralProgramModuleFromJSON(json['referralProgram']),
        'executiveReports': !exists(json, 'executiveReports') ? undefined : PublicModuleFromJSON(json['executiveReports']),
        'continuityOfCare': !exists(json, 'continuityOfCare') ? undefined : PublicContinuityOfCareModuleFromJSON(json['continuityOfCare']),
        'refillRequests': !exists(json, 'refillRequests') ? undefined : PublicModuleFromJSON(json['refillRequests']),
    };
}

export function PublicTenantModulesToJSON(value?: PublicTenantModules | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dynacare': PublicModuleToJSON(value.dynacare),
        'fax': PublicModuleToJSON(value.fax),
        'sms': PublicModuleToJSON(value.sms),
        'blog': PublicModuleToJSON(value.blog),
        'twoFactorAuth': PublicModuleToJSON(value.twoFactorAuth),
        'ses': PublicModuleToJSON(value.ses),
        'stripe': PublicStripeModuleToJSON(value.stripe),
        'cycleTracking': PublicModuleToJSON(value.cycleTracking),
        'careyChat': PublicModuleToJSON(value.careyChat),
        'careyEmail': PublicModuleToJSON(value.careyEmail),
        'referralProgram': PublicReferralProgramModuleToJSON(value.referralProgram),
        'executiveReports': PublicModuleToJSON(value.executiveReports),
        'continuityOfCare': PublicContinuityOfCareModuleToJSON(value.continuityOfCare),
        'refillRequests': PublicModuleToJSON(value.refillRequests),
    };
}

